
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { ICiudad } from '../models/ciudad';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { IChofer } from '../models/chofer';
import { IChoferDisponible } from '../models/choferdisponible';
import { IChoferDisponibleManiobras } from '../models/choferdisponible_maniobras';
import { Ipuestos } from '../models/Ipuestos';
import { InombreCompletoChofer } from '../models/nombreCompletoChofer';
import { IEstado } from '../models/estado';
@Injectable({
  providedIn: 'root'
})
export class EstadosService {
  private apiUrl: string ='';
  constructor(private http: HttpClient) {
    this.apiUrl = environment.SUrlgApi + 'Estado';
  }

  getListEstados(): Observable<IEstado[]> {
    return this.http
      .get<IEstado[]>(this.apiUrl+'/getEstados/')
      .pipe(retry(1), catchError(this.handleError));
  }

  handleError(error:any) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // client-side error
      errorMessage = `Error: ${error.error.message}`;
    } else {
      // server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    console.log(errorMessage);
    return throwError(() => {
        return errorMessage;
    });
  }
}
